import { render, staticRenderFns } from "./ai-generated-note.vue?vue&type=template&id=1e57e250&scoped=true&"
import script from "./ai-generated-note.vue?vue&type=script&lang=js&"
export * from "./ai-generated-note.vue?vue&type=script&lang=js&"
import style0 from "./ai-generated-note.vue?vue&type=style&index=0&id=1e57e250&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e57e250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e57e250')) {
      api.createRecord('1e57e250', component.options)
    } else {
      api.reload('1e57e250', component.options)
    }
    module.hot.accept("./ai-generated-note.vue?vue&type=template&id=1e57e250&scoped=true&", function () {
      api.rerender('1e57e250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/back-office/components/ai-generated-note/ai-generated-note.vue"
export default component.exports